import { useState } from "react";

import { makePostApiCall, makePutApiCall } from "../../../shared/makeApiCall";
import VisitorTypesForm from "../../../components/forms/setup/visitorTypes/VisitorTypesForm";
import DeleteConfirmationForm from "../../../components/forms/DeleteConfirmationForm";
import { SnackbarData, SnackbarType } from "../../../components/Snackbar";
import { generateUniqueNumber } from "../../../shared/utility";
import ModelErrorComponent from "../../../components/modals/ModelErrorComponent";

export function VisitorTypesViewModel(logout, addSnackbar) {
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });
  const [loading, setLoading] = useState(false);
  const [visitorTypes, setVisitorTypes] = useState({ data: [] });

  const [slideOver, setSlideOver] = useState({
    childComponent: null,
    open: false,
  });

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const getVisitorTypes = async function (search, page) {
    setLoading(true);
    const payload = {
      page: page,
      search: search,
    };
    let callResult = await makePostApiCall(`visitorTypes`, payload);
    setLoading(false);
    if (callResult.success) {
      setVisitorTypes(callResult.data);
    } else {
      showErrorModal(callResult.data?.message || "Error loading visitor types");
    }
  };

  const createVisitorType = async function (values) {
    const payload = { ...values };
    let callResult = await makePostApiCall("createVisitorType", payload);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Visitor Type added",
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getVisitorTypes("", 1);
      }, 1000);
    } else {
      showErrorModal(callResult.data?.message || "Error adding visitor type");
    }
  };

  const updateVisitorType = async function (visitorType, values, index) {
    let callResult = await makePutApiCall(`visitorTypes/${visitorType.id}`, values);

    if (callResult.success) {
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          "Visitor Type updated",
          SnackbarType.Success
        )
      );
      setSlideOver({
        childComponent: null,
        open: false,
      });
      setTimeout(function () {
        getVisitorTypes("", 1);
      }, 1000);
    } else {
      showErrorModal(callResult.data?.message || "Error updating visitor type");
    }
  };

  const openAddVisitorTypeSlideOver = () => {
    setSlideOver({
      childComponent: (
        <VisitorTypesForm
          isEdit={false}
          setOpen={setSlideOver}
          actionCall={createVisitorType}
        />
      ),
      open: true,
    });
  };

  const viewVisitorTypeDetails = async function (visitorType, index) {
    setSlideOver({
      childComponent: (
        <VisitorTypesForm
          visitorType={visitorType}
          index={index}
          isEdit={true}
          setOpen={setSlideOver}
          actionCall={updateVisitorType}
        />
      ),
      open: true,
    });
  };

  const deleteVisitorType = async function (id, index) {
    setLoading(true);

    let callResult = await makePostApiCall(`deleteVisitorType/${id}`, {});
    setLoading(false);
    if (callResult.success) {
      setEmptyModelOpen({
        open: false,
        childComponent: null,
      });
      getVisitorTypes(null, 0);
      addSnackbar(
        new SnackbarData(
          generateUniqueNumber(),
          callResult.data?.message || "Visitor Type deleted",
          SnackbarType.Success
        )
      );
    } else {
      showErrorModal(callResult.data?.message || "Error deleting visitor type");
    }
  };

  const askDeleteVisitorType = function (visitorType, index) {
    setEmptyModelOpen({
      childComponent: (
        <DeleteConfirmationForm
          buttonMessage="Delete"
          confirmAction={() => deleteVisitorType(visitorType.id, index)}
          message={`Are you sure you want to delete ${visitorType.name}?`}
          setOpen={setEmptyModelOpen}
        />
      ),
      open: true,
    });
  };

  return {
    askDeleteVisitorType,
    emptyModal,
    setEmptyModelOpen,
    createVisitorType,
    getVisitorTypes,
    loading,
    visitorTypes,
    openAddVisitorTypeSlideOver,
    setSlideOver,
    slideOver,
    updateVisitorType,
    viewVisitorTypeDetails,
  };
}

